import { useEffect, useState } from "react";
import { api, formatMoney, formatDate, todayISO } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, X, Check } from "lucide-react";

export default function UpcomingPayments() {
  const [items, setItems] = useState([]);
  const [cari, setCari] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ type: "payment", title: "", cari_id: "", amount: "", currency: "TRY", due_date: todayISO(), notes: "" });

  const load = async () => {
    const [u, c] = await Promise.all([api.get("/upcoming"), api.get("/cari")]);
    setItems(u.data); setCari(c.data);
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/upcoming", { ...form, amount: Number(form.amount) });
      toast.success("Kaydedildi");
      setOpen(false); setForm({ type: "payment", title: "", cari_id: "", amount: "", currency: "TRY", due_date: todayISO(), notes: "" });
      load();
    } catch { toast.error("Kayıt başarısız"); }
  };
  const markPaid = async (id) => { await api.put(`/upcoming/${id}`, { status: "paid" }); toast.success("Tamamlandı"); load(); };
  const del = async (id) => { if (!window.confirm("Silinsin mi?")) return; await api.delete(`/upcoming/${id}`); load(); };

  const badge = (s) => {
    if (s === "overdue") return "bg-rose-100 text-rose-700";
    if (s === "paid") return "bg-emerald-100 text-emerald-700";
    return "bg-amber-100 text-amber-700";
  };
  const label = (s) => s === "overdue" ? "Vadesi Geçmiş" : s === "paid" ? "Ödendi" : "Beklemede";

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-slate-500 font-bold">Vade Takibi</div>
          <h1 className="font-display text-4xl font-extrabold text-slate-900 mt-1">Ödemeler & Tahsilatlar</h1>
        </div>
        <button data-testid="add-upcoming" onClick={() => setOpen(true)} className="flex items-center gap-2 px-5 py-3 rounded-xl bg-[#1E2A9C] text-white font-bold hover:bg-[#121A68] shadow-lg shadow-[#1E2A9C]/20"><Plus className="w-4 h-4" /> Yeni Kayıt</button>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 uppercase text-[10px] tracking-widest">
            <tr>
              <th className="text-left px-6 py-3 font-bold">Tip</th>
              <th className="text-left px-6 py-3 font-bold">Başlık</th>
              <th className="text-left px-6 py-3 font-bold">Cari</th>
              <th className="text-left px-6 py-3 font-bold">Vade</th>
              <th className="text-left px-6 py-3 font-bold">Durum</th>
              <th className="text-right px-6 py-3 font-bold">Tutar</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={7} className="text-center py-16 text-slate-400">Kayıt yok</td></tr>}
            {items.map(u => (
              <tr key={u.id} className="border-t border-slate-100 hover:bg-slate-50/50">
                <td className="px-6 py-4">
                  <span className={`px-2.5 py-1 rounded-md text-xs font-bold ${u.type === "collection" ? "bg-emerald-100 text-emerald-700" : "bg-rose-100 text-rose-700"}`}>
                    {u.type === "collection" ? "Tahsilat" : "Ödeme"}
                  </span>
                </td>
                <td className="px-6 py-4 font-semibold text-slate-800">{u.title}</td>
                <td className="px-6 py-4 text-slate-600">{cari.find(c => c.id === u.cari_id)?.name || "-"}</td>
                <td className="px-6 py-4 font-mono-num text-slate-700">{formatDate(u.due_date)}</td>
                <td className="px-6 py-4"><span className={`px-2.5 py-1 rounded-md text-xs font-bold ${badge(u.status)}`}>{label(u.status)}</span></td>
                <td className={`px-6 py-4 text-right font-mono-num font-bold ${u.type === "collection" ? "text-emerald-600" : "text-rose-600"}`}>{formatMoney(u.amount, u.currency)}</td>
                <td className="px-6 py-4 text-right">
                  <div className="flex justify-end gap-2">
                    {u.status !== "paid" && <button data-testid={`paid-${u.id}`} onClick={() => markPaid(u.id)} className="text-emerald-600 hover:text-emerald-700"><Check className="w-4 h-4" /></button>}
                    <button data-testid={`del-upc-${u.id}`} onClick={() => del(u.id)} className="text-slate-400 hover:text-rose-600"><Trash2 className="w-4 h-4" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {open && (
        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm z-50 grid place-items-center p-4">
          <form onSubmit={submit} className="bg-white rounded-2xl w-full max-w-lg p-8 relative">
            <button type="button" onClick={() => setOpen(false)} className="absolute top-4 right-4"><X className="w-5 h-5" /></button>
            <div className="font-display text-2xl font-extrabold mb-6">Yeni Ödeme / Tahsilat</div>
            <div className="grid grid-cols-2 gap-4">
              <div><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Tip</label>
                <select data-testid="upc-type" value={form.type} onChange={(e) => setForm({...form, type: e.target.value})} className="w-full mt-1 px-3 py-2 border rounded-lg">
                  <option value="payment">Ödeme</option><option value="collection">Tahsilat</option>
                </select></div>
              <div><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Vade</label>
                <input type="date" data-testid="upc-date" value={form.due_date} onChange={(e) => setForm({...form, due_date: e.target.value})} className="w-full mt-1 px-3 py-2 border rounded-lg" /></div>
              <div className="col-span-2"><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Başlık</label>
                <input required data-testid="upc-title" value={form.title} onChange={(e) => setForm({...form, title: e.target.value})} className="w-full mt-1 px-3 py-2 border rounded-lg" /></div>
              <div><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Tutar</label>
                <input required type="number" step="0.01" data-testid="upc-amount" value={form.amount} onChange={(e) => setForm({...form, amount: e.target.value})} className="w-full mt-1 px-3 py-2 border rounded-lg font-mono-num" /></div>
              <div><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Para Birimi</label>
                <select data-testid="upc-currency" value={form.currency} onChange={(e) => setForm({...form, currency: e.target.value})} className="w-full mt-1 px-3 py-2 border rounded-lg">
                  {["TRY","USD","EUR"].map(c => <option key={c} value={c}>{c}</option>)}
                </select></div>
              <div className="col-span-2"><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Cari</label>
                <select data-testid="upc-cari" value={form.cari_id} onChange={(e) => setForm({...form, cari_id: e.target.value})} className="w-full mt-1 px-3 py-2 border rounded-lg">
                  <option value="">-</option>
                  {cari.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select></div>
              <div className="col-span-2"><label className="text-xs uppercase font-bold text-slate-500 tracking-widest">Notlar</label>
                <textarea data-testid="upc-notes" value={form.notes} onChange={(e) => setForm({...form, notes: e.target.value})} rows="2" className="w-full mt-1 px-3 py-2 border rounded-lg"></textarea></div>
            </div>
            <button data-testid="upc-submit" className="w-full mt-6 py-3 bg-[#1E2A9C] text-white rounded-lg font-bold">Kaydet</button>
          </form>
        </div>
      )}
    </div>
  );
}
